import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import PaymentCard from "./PaymentCard";
import CombinationCard from "./CombinationCard";
import YourBookingCard from "./YourBookingCard";
import AddressCard from "./AddressCard";
import { useSelector } from "react-redux";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
import { format_Number } from "../../utils/utils";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
const CardSection = ({
  steps,
  activeStep,
  handleBack,
  handleNextFunc,
  errors,
  price,
  isLoading,
  priceButton,
  totalCount,
  languageWords,
  reservType,
  selectedDate,
  adult,
  child,
  kid,
  baby,
  toddler,
  selectedExtraProduct,
  time,
  transactionDetails,
  selectedCombination,
  transactionPrice,
  excludingVat,
  totalVat,
  totalIncludingVAT,
  totalCostYourBooking,
  combinationUpsale,
  total_product_price,
  languageId,
  touched,
  values
}) => {
  const hasErrors = Object.keys(errors || {}).some(
    (key) =>
      touched?.[key] ||
      (values?.[key] !== undefined &&
        values?.[key] !== "" &&
        values?.[key] !== false)
  );
  const theme = useTheme();
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const { css } = useSelector((store) => store?.widgetSettings);
  const cardSectionCss = css?.find((item) => item?.cssTabFieldsGroupName === "Checkout fields + sidemnu")?.fields;
  return (
    <Box>
      <AddressCard totalCount={totalCount} languageWords={languageWords} cardCss={cardSectionCss}/>
      {selectedCombination?.some((item) => item?.isBefore == true) && (
        <CombinationCard
        cardCss={cardSectionCss}
          data={selectedCombination?.find((item) => item?.isBefore == true)}
          selectedDate={selectedDate}
          reservType={reservType}
          adult={adult}
          child={child}
          kid={kid}
          baby={baby}
          toddler={toddler}
          languageWords={languageWords}
          totalCount={totalCount}
          combinationUpsale={combinationUpsale?.filter(
            (item) => item?.isBefore == true
          )}
        />
      )}
      <YourBookingCard
      cardCss={cardSectionCss}
        selectedDate={selectedDate}
        reservType={reservType}
        adult={adult}
        child={child}
        kid={kid}
        baby={baby}
        toddler={toddler}
        languageWords={languageWords}
        selectedExtraProduct={selectedExtraProduct}
        time={time}
        totalCostYourBooking={totalCostYourBooking}
        combinationUpsale={combinationUpsale}
        languageId={languageId}
      />
      {selectedCombination?.some((item) => item?.isBefore == false) && (
        <CombinationCard
        cardCss={cardSectionCss}
          data={selectedCombination?.find((item) => item?.isBefore == false)}
          selectedDate={selectedDate}
          reservType={reservType}
          adult={adult}
          child={child}
          kid={kid}
          baby={baby}
          toddler={toddler}
          languageWords={languageWords}
          totalCount={totalCount}
          combinationUpsale={combinationUpsale?.filter(
            (item) => item?.isBefore == false
          )}
        />
      )}
      {totalCount < widgetConfig?.reservationRequestMin &&
        totalIncludingVAT > 0 && (
          <PaymentCard
          cardCss={cardSectionCss}
            transactionDetails={transactionDetails}
            languageWords={languageWords}
            transactionPrice={transactionPrice}
            excludingVat={excludingVat}
            totalVat={totalVat}
            totalIncludingVAT={totalIncludingVAT}
            total_product_price={total_product_price}
          />
        )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
          gap: 2,
        }}
      >
        {/* Back Icon Button */}
        <Button
          onClick={handleBack}
          sx={{
            width: 44,
            height: 44,
            borderRadius: "8px",
            backgroundColor: cardSectionCss?.navigationBtnBgClr,
            transition: "all 0.2s ease",
            "&:hover": {
             
              color:cardSectionCss?.navigationBtnIconHoverClr,
              transform: "translateY(-2px)",
            },
          }}
        >
          <ArrowBackIosTwoToneIcon fontSize="small"
          sx={{
            color:cardSectionCss?.navigationBtnIconClr,
          }} />
        </Button>

        {/* Next / Confirm Icon Button */}
        <Button
  onClick={() => handleNextFunc(errors)}
  type={
    steps[activeStep] === languageWords?.yourDetails
      ? "submit"
      : "button"
  }
  disabled={
    (Object.keys(errors).length !== 0 &&
    steps[activeStep] === languageWords?.yourDetails) ||
    isLoading
  }
  sx={{
    width: steps[activeStep] !== languageWords?.yourDetails ? 44 : "auto",
    minWidth: steps[activeStep] === languageWords?.yourDetails ? 44 : "unset",
    height: 44,
    borderRadius: "8px",
    px: steps[activeStep] === languageWords?.yourDetails ? { xs: 1.5, sm: 2 } : 0, 
    backgroundColor: cardSectionCss?.navigationBtnBgClr,
    color: "#fff",
    transition: "all 0.2s ease",
    whiteSpace: "nowrap", 
    "&.Mui-disabled": {
      opacity: 0.5,
      backgroundColor: cardSectionCss?.navigationBtnBgClr,
    },
  }}
>
  {isLoading ? (
    <CircularProgress size={20} sx={{ color: "#fff" }} />
  ) : steps[activeStep] === languageWords?.yourDetails ? (
    <>
      {price > 0 ? (
        <>
          <CreditScoreIcon fontSize="small" sx={{ mr: 0.5 }} />
          {` € ${format_Number(parseFloat(price).toFixed(2))}`}
        </>
      ) : (
        languageWords?.Booknow ?? "Reserve"
      )}
    </>
  ) : (
    <ArrowForwardIosTwoToneIcon fontSize="small" sx={{ color: cardSectionCss?.navigationBtnIconClr }} />
  )}
</Button>
      </Box>
    </Box>
  );
};

export default CardSection;
